/* eslint-disable react/prop-types */
import Select from './Select';
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import makeAnimated from 'react-select/animated';
import { components } from 'react-select';
import { capitalizeFirstLetter } from '@utils/static/commonUtils';

// eslint-disable-next-line react/display-name
const MultiSelect = forwardRef((props: any, ref) => {
    const animatedComponents = makeAnimated();
    const [optionSelected, setoptionSelected] = useState(null);
    const [items, setItems] = useState([]);
    const allOption = {
        label: 'Select all',
        value: '*',
    };

    const handleChange = (selected, option) => {
        try {
            if (option?.removedValue?.isFixed) return;
            if (props.isSingle) {
                props.getMultiSelectValue(selected);
                setoptionSelected(selected);
                return;
            }

            // const t = (selected || []).map((i: any) => { return { [props.displayValue]: i.value, [props.displayName]: i.label } });
            const t = (selected || [])
                .map(item =>
                    item.value !== '*'
                        ? {
                            [props.displayValue]: item.value,
                            [props.displayName]: item.label,
                            isFixed: item.isFixed || false,
                        }
                        : null,
                )
                .filter(Boolean);
            props.getMultiSelectValue(t);
            console.log('selected', selected);

            setoptionSelected(selected);
        } catch (error) { }
    };

    const MultiValue = props => {
        let labelToBeDisplayed = `${props.data.label}`;
        if (props.data.value === allOption.value) {
            labelToBeDisplayed = 'All is selected';
        }
        // console.log('====', props.data, allOption)
        return (
            <components.MultiValue {...props}>
                <span>{labelToBeDisplayed}</span>
            </components.MultiValue>
        );
    };

    const Option = props => {
        return (
            <div>
                <components.Option {...props}>
                    {/* <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "} */}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };

    const styles = {
        control: base => ({
            ...base,
            //height: 58,
            minHeight: 58,
        }),
        multiValue: (base, state) => {
            return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
        },
        multiValueLabel: (base, state) => {
            return state.data.isFixed ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 } : base;
        },
        multiValueRemove: (base, state) => {
            return state.data.isFixed ? { ...base, display: 'none' } : base;
        },
    };

    useEffect(() => {
        try {
            let trnsUser: any = '';
            if (props.isSingle) {
                trnsUser = props?.setSelectedValues;
            } else {
                trnsUser = (props?.setSelectedValues || []).map((i: any) => {
                    return {
                        value: i?.[props.displayValue],
                        label: i?.[props.displayName],
                        isFixed: i.isFixed || false,
                    };
                });
            }
            setoptionSelected(trnsUser);
        } catch (error) { }
    }, [props.setSelectedValues]);

    useEffect(() => {
        const selectDefault = props.notSelectDefault ? false : true;
        const trnsUser = (props?.options || []).map((i: any) => {
            return { value: i?.[props.displayValue], label: capitalizeFirstLetter(i?.[props.displayName]) };
        });
        if (trnsUser?.length == 1 && selectDefault) {
            const d: any = trnsUser[0];
            d['isFixed'] = d.isFixed || false;
            setoptionSelected([d]);
            props?.getMultiSelectValue(d);
        }

        if (props.allSelectAll) {
            setoptionSelected(trnsUser);
            const t = (trnsUser || [])
                .map(item =>
                    item.value !== '*'
                        ? {
                            [props.displayValue]: item.value,
                            [props.displayName]: item.label,
                            isFixed: item.isFixed || false,
                        }
                        : null,
                )
                .filter(Boolean);
            props.getMultiSelectValue(t);
        }
        setItems(trnsUser);
    }, [props.options]);

    const clearDropdown = () => {
        setoptionSelected(null);
    };

    useImperativeHandle(ref, () => ({
        clearDropdown,
    }));

    const onClearValue = (e) => {
        try {
            console.log('e', e);

        } catch (error) {

        }
    }

    return (
        <>
            <div className="form-floating custom_floating_box ">
                <Select
                    options={items}
                    isDisabled={props?.isDisabled || false}
                    isMulti={props.isSingle ? false : true}
                    isSearchable={true}
                    components={{
                        Option,
                        MultiValue,
                        animatedComponents,
                    }}
                    onChange={handleChange}
                    allowSelectAll={props.isSingle ? false : true}
                    value={optionSelected}
                    name={props.displayName}
                    id={props.displayValue}
                    isClearable={props.isClearable == false ? false : true}
                    placeholder={<div className="select-placeholder-text ft-14">{props.placeholder}</div>}
                    closeMenuOnSelect={props.isSingle || false}
                    styles={styles}
                    className="font12"
                    clearValue={onClearValue}
                />
                <label className="labeltext" htmlFor="floatingInput">
                    {props.placeholder}
                </label>
            </div>
        </>
    );
});

export default MultiSelect;
